import { Button } from 'reactstrap';
import './NoteTextarea.css';
import DefaultButton from '../../../../components/Buttons/Default';
import { useState } from 'react';
import { post } from '../../../../utils/helpers/api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function NoteTextarea({ subjectId, onSave, subject }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [noteTitle, setNoteTitle] = useState('');
  const [noteContent, setNoteContent] = useState('');

  const saveNote = async () => {
    if(!noteContent) return;

    setLoading(true);

    const data = await post(`/crm/notes/store/${subject}/${subjectId}`, {
      note_title: noteTitle,
      note_body: noteContent
    });

    if(data.success) {
      setNoteTitle('');
      setNoteContent('');
      toast.success(t('notes.noteAdded'));
      onSave?.();
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }

    setLoading(false);
  }

  return(
    <div className="note-textarea-container">
      <input
        placeholder={t('crm.notePlaceholderTitle')}
        value={noteTitle}
        onChange={(e) => setNoteTitle(e.target.value)}
      />
      <textarea
        placeholder={t('crm.notePlaceholderNote')}
        value={noteContent}
        onChange={(e) => setNoteContent(e.target.value)}
      ></textarea>
      <div className='text-end px-2 py-1 border-top'>
        <DefaultButton
          color='primary'
          size='sm'
          loading={loading}
          disabled={!noteContent || loading}
          onClick={saveNote}
        >{t('common.save')}</DefaultButton>
      </div>
    </div>
  );
}

export default NoteTextarea;